export const CHALLENGES = [
  {
    id: 'C01',
    category: 'Form Interaction',
    difficulty: 'Easy',
    points: 10,
    title: 'Fill a Contact Form with Exact Values',
    description: `Fill out the contact form below using EXACTLY these values:
• First Name: "Marcus"
• Last Name: "Reeves"
• Email: "marcus.reeves@techcorp.io"
• Phone: "+1-415-882-0934"
• Department: "Engineering"
• Message: "Requesting access to the internal dashboard for Q2 reporting."
Then click Submit.`,
    type: 'FORM_FILL',
    tier: 'Foundational',
  },
  {
    id: 'C02',
    category: 'Form Interaction',
    difficulty: 'Medium',
    points: 15,
    title: 'Configure System Settings',
    description: `In the Settings panel below, configure the following:
• Theme: "Dark"
• Language: "French"
• Notifications: turn ON
• Auto-save interval: "5 minutes"
• Two-Factor Authentication: enable
• Session timeout: "30 minutes"
• Default view: "Compact"
Then click Save Settings.`,
    type: 'SETTINGS_FORM',
    tier: 'Intermediate',
  },
  {
    id: 'C03',
    category: 'Form Interaction',
    difficulty: 'Hard',
    points: 20,
    title: 'Multi-Condition Expense Report',
    description: `Submit an expense report with these exact entries:
• Expense Type: "Travel"
• Amount: 2847.50
• Currency: "USD"
• Date: 2026-03-28
• Project Code: "PRJ-2024-Q1"
• Billable: YES (checked)
• Reimbursable: YES (checked)
• Receipt Attached: NO (unchecked)
• Notes: "Flight and hotel for Austin client visit"
• Priority: "High"
Click Submit Report.`,
    type: 'EXPENSE_FORM',
    tier: 'Advanced',
  },
  {
    id: 'C04',
    category: 'Data Grid',
    difficulty: 'Easy',
    points: 10,
    title: 'Find and Report a Cell Value',
    description: `In the employee data table below:
1. Filter by Department = "Finance"
2. Sort by Salary (highest first)
3. Find the employee with the HIGHEST salary in Finance
4. Enter their full name in the answer box and click Submit Answer.`,
    type: 'DATA_FIND',
    tier: 'Foundational',
  },
  {
    id: 'C05',
    category: 'Data Grid',
    difficulty: 'Medium',
    points: 15,
    title: 'Multi-Filter and Count',
    description: `Using the employee table:
1. Filter: Department = "Engineering" AND Status = "Active" AND Level = "Senior"
2. Count how many employees match all three filters
3. Enter the count in the answer box and click Submit Answer.`,
    type: 'DATA_COUNT',
    tier: 'Intermediate',
  },
  {
    id: 'C06',
    category: 'Data Grid',
    difficulty: 'Hard',
    points: 20,
    title: 'Select Specific Rows and Perform Bulk Action',
    description: `In the task table:
1. Select ALL tasks where Priority = "High" AND Status = "Pending"
2. Click the "Mark Selected as In Progress" button
3. Verify the count of updated rows shown equals 3, then click Confirm.`,
    type: 'GRID_BULK',
    tier: 'Advanced',
  },
  {
    id: 'C07',
    category: 'Navigation',
    difficulty: 'Easy',
    points: 10,
    title: 'Navigate Tabs and Read Content',
    description: `In the tabbed interface below:
1. Click on the "Analytics" tab
2. Inside Analytics, click the "Revenue" sub-tab
3. Read the value shown for "Q3 2025 Revenue"
4. Enter that exact value in the answer box and click Submit Answer.`,
    type: 'TAB_NAVIGATE',
    tier: 'Foundational',
  },
  {
    id: 'C08',
    category: 'Navigation',
    difficulty: 'Medium',
    points: 15,
    title: 'Accordion and Modal Interaction',
    description: `Complete these steps in order:
1. Open the "Billing & Payments" accordion section
2. Click the "View Invoice #INV-2025-0892" button inside it
3. In the modal that appears, locate the "Total Due" amount
4. Click "Download PDF" in the modal
5. Close the modal using the X button
6. Enter the Total Due amount in the answer box and click Submit Answer.`,
    type: 'ACCORDION_MODAL',
    tier: 'Intermediate',
  },
  {
    id: 'C09',
    category: 'Navigation',
    difficulty: 'Hard',
    points: 20,
    title: 'Breadcrumb Deep Navigation',
    description: `Navigate through the nested menu to reach the correct page:
1. Click "Administration" in the top nav
2. Click "User Management" in the dropdown
3. Click "Roles & Permissions" in the sidebar
4. On that page, click the "Edit" button for the role named "Content Editor"
5. In the edit panel, change "Can Delete Posts" from OFF to ON
6. Click Save Role
7. Enter the full breadcrumb path shown (copy it exactly) in the answer box.`,
    type: 'DEEP_NAV',
    tier: 'Advanced',
  },
  {
    id: 'C10',
    category: 'Drag & Drop',
    difficulty: 'Medium',
    points: 15,
    title: 'Reorder Priority Queue',
    description: `The list below shows tasks in the WRONG order. Drag them to match this exact order:
1. "Deploy hotfix to production"
2. "Notify stakeholders"
3. "Run regression tests"
4. "Update changelog"
5. "Schedule post-mortem"
Once in this exact order, click Confirm Order.`,
    type: 'DRAG_ORDER',
    tier: 'Intermediate',
  },
  {
    id: 'C11',
    category: 'Drag & Drop',
    difficulty: 'Hard',
    points: 20,
    title: 'Kanban Board Reorganization',
    description: `Reorganize the Kanban board so that:
• Move "API Integration" from "In Progress" → "Review"
• Move "Write Unit Tests" from "Backlog" → "In Progress"
• Move "Fix Login Bug" from "Review" → "Done"
• Move "Update Docs" from "Done" → "Backlog"
After all 4 moves, click Verify Board.`,
    type: 'KANBAN_REARRANGE',
    tier: 'Advanced',
  },
  {
    id: 'C12',
    category: 'Conditional Logic',
    difficulty: 'Medium',
    points: 15,
    title: 'Dynamic Form — Unlock and Fill Hidden Fields',
    description: `In the insurance form:
1. Select Policy Type = "Business"
2. This should reveal the "Business Registration Number" field — enter "BRN-2024-98712"
3. Set Number of Employees = 45
4. Check "Include Liability Coverage" — this reveals a "Coverage Limit" dropdown — select "₹50 Lakhs"
5. Set Tenure = "3 years"
6. Click Calculate Premium
7. Enter the calculated premium shown in the answer box.`,
    type: 'DYNAMIC_FORM',
    tier: 'Intermediate',
  },
  {
    id: 'C13',
    category: 'Conditional Logic',
    difficulty: 'Hard',
    points: 25,
    title: 'Multi-Step Checkout with Conditional Branching',
    description: `Complete the checkout flow:
Step 1 — Cart: Remove the item "USB Hub 3.0", apply coupon code "SAVE20"
Step 2 — Shipping: Select "Express Delivery (2-day)", fill address: "742 Evergreen Terrace, Springfield, IL 62704"
Step 3 — Payment: Select "Credit Card", enter card ending in "4242", expiry "12/28", CVV "123"
Step 4 — Review: Confirm that the discount was applied correctly (20% off subtotal)
Click Place Order.
Enter the final order total shown in the answer box.`,
    type: 'MULTISTEP_CHECKOUT',
    tier: 'Advanced',
  },
  {
    id: 'C14',
    category: 'Search & Filter',
    difficulty: 'Medium',
    points: 15,
    title: 'Search, Filter and Add to Cart',
    description: `In the product catalog:
1. Search for "wireless"
2. Filter by Category = "Electronics" and Price ≤ ₹6000
3. Sort by Rating (highest first)
4. Add the TOP result to cart
5. Then search for "ergonomic" and add the FIRST in-stock result to cart
6. Go to Cart and enter the total cart value in the answer box.`,
    type: 'SEARCH_CART',
    tier: 'Intermediate',
  },
  {
    id: 'C15',
    category: 'Reasoning',
    difficulty: 'Hard',
    points: 25,
    title: 'Data Interpretation and Calculation',
    description: `Study the sales report table shown below, then answer:
1. Which region had the HIGHEST average monthly sales in Q4 2025?
2. What is the total revenue difference between the top-performing and bottom-performing regions in Q4?
3. If the growth rate from Q3 to Q4 continues linearly, what would be the projected Q1 2026 revenue for the "North" region?

Enter your answers in the three separate answer boxes (Region name, Difference in ₹, Projected Revenue in ₹) and click Submit All Answers.`,
    type: 'DATA_REASONING',
    tier: 'Advanced',
  },
  {
    id: 'C16',
    category: 'Reasoning',
    difficulty: 'Expert',
    points: 30,
    title: 'Cross-Table Revenue Analysis',
    description: `You have THREE reference tables: Orders, Customers, and Price List.
You must cross-reference them to answer:
1. Which customer (full name) generated the highest total DELIVERED revenue? (multiply qty × price, only Delivered orders)
2. How many total units of "Laptop Pro 15" are in Pending status?
3. Which customer tier (Gold/Silver/Platinum) has the most DELIVERED orders (count of orders, not units)?
Enter your answers in the three boxes.`,
    type: 'CROSS_REFERENCE',
    tier: 'Elite',
  },
  {
    id: 'C17',
    category: 'Adversarial',
    difficulty: 'Expert',
    points: 30,
    title: 'Employee Form with Traps and Decoys',
    description: `Fill the new employee onboarding form with EXACTLY these values:
• Full Name: "Jordan Blake" (field is pre-filled with a WRONG name — clear it)
• Employee ID: "EMP-20250312" (field has "(enter manually)" hint — it is NOT auto-generated)
• Role: "Engineer" (default is "Manager" — change it)
• Department: "Platform Engineering" (text field — exact spelling)
• Access Level: "Level 3" (label looks grayed out but field IS editable)
• Start Date: 2026-06-01
• Reporting Manager: "Sarah Chen"
• Send Welcome Email: UNCHECKED (it is pre-checked — uncheck it)
Click Create Employee.`,
    type: 'TRAP_FORM',
    tier: 'Elite',
  },
  {
    id: 'C18',
    category: 'Live State',
    difficulty: 'Expert',
    points: 35,
    title: 'Monitor Live Feed and Capture at Right Moment',
    description: `A live server metrics dashboard updates every 1.5 seconds.
Your task:
1. Watch the Request Rate metric
2. When the Request Rate rises ABOVE 850 req/s, immediately click "Capture Snapshot"
3. Read the frozen values and answer:
   • What is the exact Request Rate shown in the snapshot?
   • What is the Active Sessions count in the snapshot?
   • Which is the FIRST region listed as "Critical" in the snapshot?
Speed and precision matter — capture too late and values change.`,
    type: 'LIVE_STATE_PAUSE',
    tier: 'Elite',
  },
  {
    id: 'C19',
    category: 'Error Recovery',
    difficulty: 'Expert',
    points: 30,
    title: 'Deployment Config with Intentional Failure',
    description: `Configure a production deployment pipeline:
• Environment: "Production"
• Region: "ap-south-1" (careful: ap-southeast-1 also exists)
• Enable Blue-Green Deployment toggle (it appears green but is OFF by default)
• Rollback Window: "15 minutes"
Click Validate Config.
NOTE: Validation will FAIL if Rollback Window is wrong — read the error, fix the config, re-validate.
Once validation passes, click Deploy to Production.
Enter the Deployment ID shown in the success banner.`,
    type: 'UNDO_RECOVERY',
    tier: 'Elite',
  },
  {
    id: 'C20',
    category: 'Search & Filter',
    difficulty: 'Expert',
    points: 35,
    title: 'Paginated Ticket Search with Multi-Sort',
    description: `A support ticket table has 20 tickets across multiple pages (7 per page).
Answer these three questions by using filters, sorting, and pagination:
1. Filter Status="Open" + Priority="High", sort by Votes (highest first). Who is the assignee of the TOP result?
2. How many tickets total are Open AND High priority?
3. Show ALL tickets (clear filters), sort by Votes descending. What is the Ticket ID of the FIRST item on Page 2?
Click column headers to sort. Use page buttons to navigate.`,
    type: 'PAGINATED_SEARCH',
    tier: 'Elite',
  },
  {
    id: 'C21',
    category: 'Canvas & Drawing',
    difficulty: 'Medium',
    points: 20,
    title: 'Paint Zones with Matching Colors',
    description: `A canvas shows three outlined zones. Paint each zone with the CORRECT color:
• Red dashed rectangle → fill with RED
• Blue dashed circle → fill with BLUE
• Green dashed triangle → fill with GREEN
Use the color picker and brush size controls. Fill at least 45% of each zone.
Click Evaluate Painting when done.`,
    type: 'CANVAS_PAINT',
    tier: 'Intermediate',
  },
  {
    id: 'C22',
    category: 'Canvas & Drawing',
    difficulty: 'Hard',
    points: 25,
    title: 'Wire Up the Architecture Diagram',
    description: `Connect the service nodes by dragging from one node to another.
Required connections (all 4 must be present):
• Auth Service → API Gateway
• API Gateway → Database
• API Gateway → Cache
• Cache → Worker
Drag from a node to another to draw a link. Drag the same pair again to remove the link.
Click Verify Connections when done.`,
    type: 'DRAG_CONNECT',
    tier: 'Advanced',
  },
  {
    id: 'C23',
    category: 'Drag & Drop',
    difficulty: 'Medium',
    points: 20,
    title: 'Sort Items into Category Bins',
    description: `Drag each of the 10 office items from the pool into the correct category bin:
• Electronics — monitors, keyboards, mice, USB hubs
• Furniture — chairs, bookshelves, filing cabinets
• Stationery — sticky notes, pen sets, rulers
All 10 items must be placed before you can verify.
Drag an item back to the pool if you want to reposition it.
Click Verify Sorting when done.`,
    type: 'DRAG_BIN_SORT',
    tier: 'Intermediate',
  },
];

export const DIFFICULTY_COLOR = { Easy: 'var(--green)', Medium: 'var(--gold)', Hard: 'var(--red)', Expert: 'var(--accent)' };
export const CATEGORY_ICONS = {
  'Form Interaction': '📝',
  'Data Grid': '📊',
  'Navigation': '🧭',
  'Drag & Drop': '🖱',
  'Canvas & Drawing': '🎨',
  'Conditional Logic': '🔀',
  'Search & Filter': '🔍',
  'Reasoning': '🧠',
  'Adversarial': '🎯',
  'Live State': '🟡',
  'Error Recovery': '🔧',
};
